<template>
    <div class="posts-wrapper">
      <div class="packages memberships">
                        
        <div class="box-white-wrapper">
          <vs-table :data="rates" pagination max-items="50" :key="key">
              <template slot="header" v-if="userInfoData.role == Roles.Admin">
                <vs-button color="primary" @click="openModal()" type="border" icon="library_add">Agregar Tarifa</vs-button>
              </template>
              <template slot="thead">
                  <!-- <vs-th sort-key="id" class="width-30" v-if="userInfoData.role == Roles.Admin"></vs-th> -->
                  <vs-th sort-key="from">Desde</vs-th>
                  <vs-th sort-key="to">Hasta</vs-th>
                  <vs-th sort-key="rate">Precio</vs-th>
                  <vs-th sort-key="id"></vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].nombre">{{data[indextr].from}}</vs-td>
                    <vs-td :data="data[indextr].nombre">{{data[indextr].to}}</vs-td>
                    <vs-td :data="data[indextr].nombre">${{data[indextr].rate}}</vs-td>
                    
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions">
                            <a href="javascript:void(0)" @click="editRate(data[indextr], indextr)"><feather type="edit-2"/></a>
                        </div>
                    </vs-td>
                  </vs-tr>
              </template>
          </vs-table>
        </div>
      </div>
        <modalBasic :show="ModalActive">
            <div class="modal-header" slot="modal-header">{{ ModalTitle }}</div>
            <div class="modal-body" slot="modal-body">
                <form>
                    <div :class="['form-input',{'has-error': $v.rate.from.$error }]">
                        <vs-input label="Desde (lib)" v-model.trim="$v.rate.from.$model" @keypress="isNumber($event)"/>
                        <span class="error-text" v-if="$v.rate.from.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                    <div :class="['form-input',{'has-error': $v.rate.to.$error }]">
                        <vs-input label="Hasta (lib)" v-model.trim="$v.rate.to.$model" @keypress="isNumber($event)"/>
                        <span class="error-text" v-if="$v.rate.to.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                    <div :class="['form-input',{'has-error': $v.rate.rate.$error }]">
                        <vs-input label="Precio" v-model.trim="$v.rate.rate.$model" @keypress="isNumber($event)"/>
                        <span class="error-text" v-if="$v.rate.rate.$error"><feather type="info" />Este campo es requerido</span>
                    </div>
                </form>
            </div>
            <div class="modal-footer" slot="modal-footer">
                <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                    @click="handleRequestRate" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
            </div>
        </modalBasic>
    </div>
</template>
<script>

import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import RatesModel from '@/models/RatesModel';
import { required } from 'vuelidate/lib/validators'
import modalBasic from '@/components/Modal/Basic.vue'
import MembershipService from "@/services/MembershipService"

export default {
    name: 'MembershipsView',
    mixins: [helper],
    components: { modalBasic },
    data () {
        return {
            key: 1,
            rates: [],
            rate: new RatesModel(),
            ModalTitle: 'Nueva tarifa',
            ModalActive: false,
            confirmStatus: false,
            isUpdating: false,
            tempRate: ""

        }
    },
    created(){
        this.Roles = Role
        this.getRates()
    },
    computed: {
        ...mapState([
        'userInfoData'
        ]),
    },
    validations: {
        rate: 
        { 
            to: { required },
            rate: { required },
            from: { required },
        },
    },
    methods: {
        async getRates () {
            let response = await MembershipService.getRates()
            console.log(response)
            if((response.status / 100) == 2) {
                this.rates = response.data.ranges
            }
        },
        handleRequestRate() {
            this.$v.$touch()
            if (this.$v.$invalid) return;
            if (!this.isUpdating) {
                this.saveRate()
            } else {
                this.updateRate()
            }
        },
        saveRate(){
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            MembershipService.addCashbackRates(that.rate)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Creado!',text:'La tarifa fue creada exitosamente!',color:'success',icon:'check'})
                that.rate = new RatesModel()
                this.$v.$reset()
                this.rates.push(response.data.range)
            })
            .catch(e => {
                console.log(e)
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.confirmStatus = false
                that.$vs.notify({title:'Información!',text:'Error agregando la tarifa',color:'danger',icon:'error_outline'})                
            });
        },
        updateRate() {
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            MembershipService.updateCashbackRates(that.rate)
            .then(response => {
                that.confirmStatus = false
                console.log(response)
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Información!',text:'La tarifa fue modificada exitosamente!',color:'success',icon:'check'})
                console.log('pos', this.tempRate)
                this.rates[this.tempRate] = that.rate
                this.key++
                that.rate = new RatesModel()
                this.$v.$reset()
            })
            .catch(e => {
                console.log(e)
                that.ModalActive = false
                that.confirmStatus = false
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.$vs.notify({title:'Información!',text:'Error actualizando la taria',color:'danger',icon:'error_outline'})
            });

        },
        
        editRate (obj, pos) {
          this.tempRate = pos
          this.ModalTitle  = "Editar Tarfia"
          this.rate = JSON.parse(JSON.stringify(obj));
          this.ModalActive = true
          this.isUpdating  = true
        },        
        openModal () {
          this.rate    = new RatesModel()
          this.ModalActive = true
          this.isUpdating  = false
          this.$v.$reset()
        },
        closeModal () {
            this.ModalTitle  = 'Nueva Tarifa'
            this.ModalActive = false
            this.rate    = new RatesModel()
            this.$v.$reset()
        },
        
    }
}
</script>
